import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import { CustomStyledBox } from '../../../../shared/IconLargeCicle/style';
import Grid from '@mui/material/Grid';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
type Props = {
  errorCallback: () => void;
};
export default function Error({ errorCallback }: Props) {
  const retry = () => {
    if (errorCallback) {
      errorCallback();
    }
  };
  return (
    <>
      <Grid>
        <CustomStyledBox sx={{ backgroundColor: 'brand.lightGreen' }}>
          <CheckIcon />
        </CustomStyledBox>
      </Grid>
      <Grid>
        <Typography variant="h2" sx={{ mb: 1 }}>
          Código inválido
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Não reconhecemos o código apresentado.
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Por favor tente novamente. Caso se mantenha inválido, entre em contato com a Oya.
        </Typography>
      </Grid>
      <Grid sx={{ my: 3 }}>
        <Button
          sx={{ display: 'inline-flex', justifyContent: 'space-between' }}
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => retry()}
        >
          Tentar novamente
        </Button>
      </Grid>
      <Grid sx={{ my: 3 }}>
        <Button variant="inline" color="primary" href={process.env.REACT_APP_WHATSAPP || ''} target="_blank">
          Falar com a Oya
        </Button>
      </Grid>
    </>
  );
}
